module.exports = __webpack_public_path__ + "static/media/digital-document.6fa6445f.svg";